require.register("modules/m05/m05-activity/page-12d/page-12d", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page12d = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page12d;

  
});

